<template>
  <div class="about">
    <h1>Event Blog</h1>
    <p>
      Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus recusandae
      impedit fugit. Dignissimos aspernatur dolorum accusamus soluta? Quisquam
      illum ipsa mollitia distinctio? Quis iure beatae labore illo excepturi
      voluptate explicabo!
    </p>
  </div>
</template>
